const productionApiUrl = 'https://nabizadeco.ir/api/';
const productionDirectImagesUrl = 'https://nabizadeco.ir/direct/';

// Local Laragon: `npm start` loads `.env.development` (see repo root).
export const apiUrl = process.env.REACT_APP_API_URL || productionApiUrl;
export const directImagesUrl =
  process.env.REACT_APP_DIRECT_IMAGES_URL || productionDirectImagesUrl;
